import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowsMaximize = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-arrows-maximize",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M16 4l4 0l0 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 10l6 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 20l-4 0l0 -4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 20l6 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 20l4 0l0 -4" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 14l6 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 4l-4 0l0 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 4l6 6" })
	]
});
export default SvgArrowsMaximize;
